// src/components/awards/TinkermanLeagueList.jsx
import React from 'react';
import { useLeagueData, useManagerContext } from '../../context/DataContext';

const TinkermanLeagueList = () => {
  const { data } = useLeagueData();
  const { selectedManager } = useManagerContext();
  
  // Find the managers with the highest transfer costs
  const findTopTinkermen = () => {
    if (!data || !data['Weekly Points']) return [];
    
    try {
      // Check if the data has the required columns
      const firstRow = data['Weekly Points'][0];
      
      if (!firstRow || 
          !('Total_Transfer_Cost' in firstRow) || 
          !('Raw_Total' in firstRow) || 
          !('Total' in firstRow)) {
        console.warn('Transfer cost data not found in Weekly Points sheet');
        return [];
      }
      
      // Get all managers with their transfer costs
      const managerTransferCosts = Object.values(data['Weekly Points'])
        .filter(row => row.Manager && row.Total_Transfer_Cost !== undefined)
        .map(row => ({
          name: row.Manager,
          transferCost: row.Total_Transfer_Cost,
          rawTotal: row.Raw_Total,
          totalPoints: row.Total,
          costPercentage: ((row.Total_Transfer_Cost / row.Raw_Total) * 100).toFixed(1)
        }))
        .sort((a, b) => b.transferCost - a.transferCost);
      
      // Return the top 3 managers with highest transfer costs
      return managerTransferCosts.slice(0, 3);
    } catch (error) {
      console.error('Error finding Tinkerman winners:', error);
      return [];
    }
  };

  const topTinkermen = findTopTinkermen();
  
  // If no data is available, don't render the component
  if (topTinkermen.length === 0) return null;

  return (
    <div className="bg-amber-900/20 rounded-lg p-5 border border-amber-700/30">
      <h4 className="font-medium text-amber-300 mb-3 flex items-center">
        <span className="mr-2 text-xl">👆</span>
        The Tinkerman
      </h4>
      
      <p className="text-xs text-amber-200/70 mt-1 mb-3">
        Managers who lost the most points to transfer costs throughout the season.
      </p>
      
      <div className="space-y-3">
        {topTinkermen.map((manager, index) => (
          <div 
            key={index} 
            className={`flex items-center justify-between p-3 rounded-lg ${
              index === 0 ? 'bg-amber-600/20 border border-amber-500' : 'bg-white/5'
            }`}
          >
            <div className="flex items-center">
              <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-2 text-xs ${
                index === 0 ? 'bg-amber-500' : 'bg-amber-900'
              }`}>
                {index + 1}
              </div>
              <span className={`${index === 0 ? 'font-medium' : ''}`}>{manager.name}</span>
            </div>
            <div className={`${index === 0 ? 'font-bold text-amber-400' : 'text-amber-300'}`}>
              {manager.transferCost} pts
            </div>
          </div>
        ))}
        
        {/* User's stats if they are the current manager and not in top 3 */}
        {selectedManager && !topTinkermen.some(manager => manager.name === selectedManager) && (
          <div className="mt-4 p-3 bg-amber-900/30 rounded-lg border border-amber-700/50">
            <div className="text-sm text-amber-300 mb-1">Your Transfer Costs</div>
            <div className="flex justify-between">
              <span>
                {data['Weekly Points']?.findIndex(m => m.Manager === selectedManager && m.Total_Transfer_Cost !== undefined) !== -1 ? 
                  `${data['Weekly Points']?.filter(m => m.Manager === selectedManager)[0]?.Total_Transfer_Cost || 0} points lost` :
                  "Not available"}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TinkermanLeagueList;